enum SalePageTypeValue {
  Simple = 1, // 單一
  Group = 2, // 組合
  Any = 3, // 任選
}

export default SalePageTypeValue;
